"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationModel = void 0;
/* eslint-disable max-len */
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const Model_1 = __importDefault(require("../Model"));
const ModelRegistry_1 = __importDefault(require("../ModelRegistry"));
class ConversationModel extends Model_1.default {
    constructor(o) {
        var _a;
        super(o);
        this.title = '';
        this.messages = [];
        this.participants = [];
        this.admins = [];
        super.init(o);
        if (o === null || o === void 0 ? void 0 : o.messages) {
            o.messages = (_a = o.messages) === null || _a === void 0 ? void 0 : _a.filter(z => z).map(comment => {
                comment.commentDate = (0, moment_timezone_1.default)(comment.commentDate);
            });
        }
    }
    get __typename() {
        return 'Conversation';
    }
    set __typename(v) {
    }
}
exports.ConversationModel = ConversationModel;
ConversationModel.ALL_FIELDS = `id, title, messages,
	participants { id, title, hasProfileImage, profileImageUrl }
	relatedOp { id, title, startFrom, completeBy, actualStart, actualComplete, isScoreEnabled, isAdhoc },
	relatedIssue { id, title, status, flag }`;
exports.default = ConversationModel;
ModelRegistry_1.default[DataType_1.default.CONVERSATION] = ConversationModel;
